import React from 'react';
import { extensions, i18next } from '@yola/ws-sdk';
import LineAndParagraphSpacingTrigger from '../components/line-and-paragraph-spacing-trigger';
import constants from '../constants';
import typedElementsMatches from '../helpers/typed-elements-matches';
import { LINE_AND_PARAGRAPH_SPACING_TRIGGER_ID } from '../constants/line-and-paragraph-spacing-trigger-ids';

const {
  common: { SLUG },
} = constants;
const { controlTypes } = extensions;

const elementMatches = (element) => {
  const { textContainer } = extensions.accessors.getExtensionSettings(SLUG);

  const typedElements = typedElementsMatches();

  if (!element.matches(textContainer)) {
    return false;
  }

  return Boolean(typedElements.length);
};

const lineAndParagraphSpacingControl = {
  id: LINE_AND_PARAGRAPH_SPACING_TRIGGER_ID,
  trigger: <LineAndParagraphSpacingTrigger triggerId={LINE_AND_PARAGRAPH_SPACING_TRIGGER_ID} />,
  get tooltip() {
    return i18next.t('Line & Paragraph spacing');
  },
  priority: 60,
  for: [controlTypes.TEXT, controlTypes.COLLAPSED_TEXT],
  matches: elementMatches,
  highlightElement: false,
};

export default lineAndParagraphSpacingControl;
